import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Card, Steps, Tooltip, Collapse, Modal } from "antd";
import LoadingArea from "../../components/LoadingArea";
import axios from "axios";
import BASE from "../../config";
import ReactLoading from "react-loading";
import { SearchOutlined, EditOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { Table } from "antd";
import { DatePicker, Tag } from "antd";
import moment from "moment";
import { formatDateDDMMYYYY } from "../../utils/commonFunctions";
import useRole from "../../hooks/useRole";
import { checkPermission } from "../../utils/checkPermission";

const { RangePicker } = DatePicker;

function ServiceSettings() {
  const [open, setOpen] = useState(false);
  const [disableEdit, setDisableEdit] = useState(true);
  const [load, setLoad] = useState(false);
  const [disable, setDisable] = useState(true);
  const [editableData, setEditableData] = useState({
    _id: "",
    name: "",
    start: "",
    end: "",
    active: ""
  });
  const oneMonthLater = new Date();
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 2);
  const [active, setActive] = useState(null);
  const [serviceName, setServiceName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [defaultDate, setDefaultDate] = useState([
    moment(new Date(oneMonthLater)).format("YYYY-MM-DD")
  ]);
  const [editDefaultDate, setEditDefaultDate] = useState();
  const [canViewServiceSettings, setCanViewServiceSettings] = useState(false);
  const [canEditServiceSettings, setCanEditServiceSettings] = useState(false);
  const [canSubmitServiceSettings, setCanSubmitServiceSettings] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const [viewAllowed, editAllowed, submitAllowed] = await Promise.all([
        checkPermission(userRole, "service_setting_module", "view_service_settings"),
        checkPermission(userRole, "service_setting_module", "edit_service_settings"),
        checkPermission(userRole, "service_setting_module", "submit_service_settings"),
      ]);

      setCanViewServiceSettings(viewAllowed);
      setCanEditServiceSettings(editAllowed);
      setCanSubmitServiceSettings(submitAllowed);
    } catch (error) {
      console.error("Permission check failed for Service Setting Module:", error);
    }
  };

  const editHandling = async (e) => {
    setLoad(true);
    const config = {
      url: BASE.api + `/serviceSettings/${editableData._id}`,
      method: "put",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      },
      data: {
        serviceName: editableData.name,
        startDate: editableData.start,
        endDate: editableData.end,
        isActive: editableData.active
      }
    };

    try {
      const edit = await axios(config);
      getAllServices();
      setOpen(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  const createServiceHandler = async (e) => {
    e.preventDefault();
    setLoad(true);
    const config = {
      url: BASE.api + "/serviceSettings",
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      },
      data: {
        serviceName: serviceName,
        startDate: defaultDate[0],
        endDate: defaultDate[1],
        isActive: active
      }
    };
    try {
      const response = await axios(config);
      if (response.data.status) {
        getAllServices();
        setServiceName("");
        setActive(null);
        setDisable(true);
      }
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };
  


  const getAllServices = async () => {
    setLoad(true);
    const config = {
      url: BASE.api + "/serviceSettings",
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("user.token")}`
      }
    };
    try {
      const service = await axios(config);
      console.log(service);
      let data = [];
      for (let i = 0; i < service.data?.SettingDetails?.length; i++) {
        data.push({
          sno: i + 1,
          name: service.data?.SettingDetails[i]?.serviceName,
          start_date: formatDateDDMMYYYY(
            new Date(service.data?.SettingDetails[i]?.startDate)
          ),
          end_date: formatDateDDMMYYYY(
            new Date(service.data?.SettingDetails[i]?.endDate)
          ),
          status: service.data?.SettingDetails[i]?.isActive ? (
            <Tag color="success">Active</Tag>
          ) : (
            <Tag color="error">In Active</Tag>
          ),
          originalData: service.data?.SettingDetails[i]
        });
      }
      setTableData([...data]);
      setLoad(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  

  useEffect(() => {
    getAllServices();
  }, []);

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  useEffect(() => {
    if (serviceName !== "" && active !== "") {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [serviceName, active]);

  useEffect(() => {
    if (editableData.name !== "" && editableData.active !== "") {
      setDisableEdit(false);
    } else {
      setDisableEdit(true);
    }
  }, [editableData]);

  const columns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno"
    },
    {
      title: "Service Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name > b.name,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.name.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      sorter: (a, b) => a.start_date > b.start_date,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.start_date.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      sorter: (a, b) => a.end_date > b.end_date,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.end_date.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status > b.status,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.status.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      align: "center",
      render: (text, record) => {
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "1rem" }}
          >
            {canEditServiceSettings && (
              <EditOutlined
                style={{ fontSize: "20px", color: "#08c" }}
                onClick={(e) => {
                  setOpen(true);
                  setEditableData({
                    ...editableData,
                    _id: record.originalData?._id,
                    name: record.originalData?.serviceName,
                    start: record.originalData?.startDate,
                    end: record.originalData?.endDate,
                    active: record.originalData?.isActive,
                  });
                }}
              />
            )}
          </div>
        );
      },
    }
  ];

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD")
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  const editHandleDate = (value, dateString) => {
    if (value === null) {
      setDisableEdit(
        {
          ...editableData,
          start: moment(new Date()).format("YYYY-MM-DD"),
          end: moment(new Date()).format("YYYY-MM-DD")
        }
      );
    } else {
      setEditableData(
        {
          ...editableData,
          start: dateString[0],
          end: dateString[1]
        }
      );
    }
  }
  if (!canViewServiceSettings) {
    return <div></div>;
  }

  return (
    <Dashboard title="Digital Document">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row">
        <div className="col-md-12">
          <Card title="Create Services" className="border mt-1">
            <div className="row mb-4">
              <div className="col-md-4">
                <input
                  type="text"
                  className="border form-control"
                  placeholder="Enter Service Name"
                  onChange={(e) => setServiceName(e.target.value)}
                  value={serviceName}
                />
              </div>
              <div className="col-md-3">
                <RangePicker
                  style={{ height: "37px" }}
                  className=""
                  format="YYYY-MM-DD"
                  defaultValue={[
                    moment(new Date(moment(new Date()).format("YYYY-MM-DD"))),
                    moment(
                      new Date(
                        moment(new Date(oneMonthLater)).format("YYYY-MM-DD")
                      )
                    )
                  ]}
                  onChange={handleDate}
                  // disabledDate={disabledDate}
                  placeholder={[
                    moment(new Date()).format("YYYY-MM-DD"),
                    moment(new Date()).format("YYYY-MM-DD")
                  ]}
                />
              </div>
              <div className="col-md-3">
                <select
                  id="FormType"
                  className="mb-2 form-control"
                  onChange={(e) => setActive(e.target.value)}
                  value={active}>
                  <option value="">Select Service Status</option>
                  <option value={true}>Active</option>
                  <option value={false}>In Active</option>
                </select>
              </div>
              <div className="text-center col-md-2">
                {canSubmitServiceSettings && (
                  <button
                    className={`btn ${!disable ? "btn-primary" : "btn-secondary"
                      }`}
                    type="submit"
                    onClick={createServiceHandler}
                    disabled={disable}>
                    Submit
                  </button>
                )}
              </div>
            </div>
          </Card>
        </div>
        <div className="col-md-12 mb-4">
          <Card title="Service List" className="border mt-3">
            <div style={{ width: "100%" }}>
              <Table
                columns={columns}
                dataSource={tableData}
                pagination={{
                  total: 0,
                  pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
                  showSizeChanger: false
                }}
                scroll={{ x: true }}
                style={{ whiteSpace: "pre" }}
              />
            </div>
          </Card>
        </div>
        <Modal
          title="Edit Service"
          centered
          open={open}
          footer={false}
          onOk={() => {
            setEditableData({
              _id: "",
              name: "",
              start: "",
              end: "",
              active: ""
            })
            setOpen(false)
          }
          }
          onCancel={() => {
            setEditableData({
              _id: "",
              name: "",
              start: "",
              end: "",
              active: ""
            })
            setOpen(false)
          }}
          width={500}>
          <div className="row">
            <div className="col-md-12">
              <div className="row mb-4">
                <div className="col-md-12 mb-4">
                  <RangePicker
                    style={{ height: "37px", width: "100%" }}
                    className=""
                    format="YYYY-MM-DD"
                    value={[
                      moment(
                        new Date(
                          moment(new Date(editableData.start)).format(
                            "YYYY-MM-DD"
                          )
                        )
                      ),
                      moment(
                        new Date(
                          moment(new Date(editableData.end)).format(
                            "YYYY-MM-DD"
                          )
                        )
                      )
                    ]}
                    onChange={editHandleDate}
                  />
                </div>
                <div className="col-md-12">
                  <select
                    id="FormType"
                    className="mb-2 form-control"
                    value={editableData.active}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        active: e.target.value
                      })
                    }>
                    <option value="">Select Service Status</option>
                    <option value={true}>Active</option>
                    <option value={false}>In Active</option>
                  </select>
                </div>
              </div>
              <input
                type="text"
                className="border form-control"
                placeholder="Enter Service Name"
                onChange={(e) =>
                  setEditableData({
                    ...editableData,
                    name: e.target.value
                  })
                }
                value={editableData.name}
              />
              <div className="text-center">
                {canEditServiceSettings && (
                  <button
                    className={`btn mt-4 ${!disableEdit ? "btn-primary" : "btn-secondary"
                      }`}
                    type="submit"
                    onClick={editHandling}>
                    Update
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </Dashboard>
  );
}

export default ServiceSettings;
